import useTranslation from "@/hooks/useTranslation";
import { useMediaQuery } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import dynamic from "next/dynamic";

const Editor = dynamic(() => import("../Editor"), { ssr: false });

interface IProps {
  open: boolean;
  handleClose: () => void;
  content: string;
  handleUpdate: (props: {
    fatherId: string;
    content: string;
    response: string;
  }) => Promise<void>;
  loadingUpdate: boolean;
  id: string;
}

const EditCommentDialog: React.FC<IProps> = ({
  open,
  handleClose,
  content,
  handleUpdate,
  loadingUpdate,
  id,
}) => {
  const { t } = useTranslation("common");
  const matches = useMediaQuery("(max-width:600px)");

  return (
    <Dialog open={open} onClose={handleClose} fullScreen={matches}>
      <DialogTitle>{t("comment.update.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Editor
            fatherId={id}
            value={content}
            submitting={loadingUpdate}
            handleSubmit={handleUpdate}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("cancel")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCommentDialog;
